document.addEventListener("DOMContentLoaded", function () {
    // Tabs - Serviços
    const tabItems = document.querySelectorAll('.item-tabs-services');
    const contentItems = document.querySelectorAll('.item-content-services');
    tabItems.forEach((tab, index) => {
        tab.addEventListener('click', function () {
            tabItems.forEach(t => t.classList.remove('active'));
            contentItems.forEach(c => c.classList.remove('active'));
            tab.classList.add('active');
            contentItems[index].classList.add('active');
        });
    });
    // Menu mobile
    const navButton = document.querySelector('.nav-button');
    const nav = document.querySelector('nav');
    const body = document.body;
    if (navButton) {
        navButton.addEventListener('click', function() {
            if (navButton.classList.contains('active')) {
                navButton.classList.remove('active');
                nav.classList.remove('active');
                body.classList.remove('overflow');
            } else {
                navButton.classList.add('active');
                nav.classList.add('active');
                body.classList.add('overflow');
            }
        });
    } else {
        console.error("Elemento .nav-button não encontrado");
    }
    const navLinks = nav.querySelectorAll('a');
    navLinks.forEach(link => {
        link.addEventListener('click', function() {
            navButton.classList.remove('active');
            nav.classList.remove('active');
            body.classList.remove('overflow');
        });
    });
    // Anchor nav
    const navAnchors = document.querySelectorAll('nav a');
    navAnchors.forEach(link => {
      link.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href');
        if (targetId && targetId.startsWith('#')) {
          e.preventDefault();
          const targetSection = document.querySelector(targetId);
          if (targetSection) {
            const rect = targetSection.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const offset = window.innerWidth >= 992 ? 100 : 60;
            const targetPosition = rect.top + scrollTop - offset;
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }
        }
      });
    });
    // Scroll reveal
    function checkVisibility() {
      const elements = document.querySelectorAll('.scroll:not(.visible)');
      const viewportMiddle = window.innerHeight / 1.5;
      elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementTop = rect.top;
    
        if (elementTop <= viewportMiddle) {
          el.classList.add('visible');
        }
      });
    }
    window.addEventListener('scroll', checkVisibility);
    window.addEventListener('resize', checkVisibility);
    document.addEventListener('DOMContentLoaded', checkVisibility);
    // Current year
    const year = new Date().getFullYear();
    document.getElementById("current-year").textContent = year;
});